// Step size widens as the amount grows: 64% of DE requests are under €50,000,
// and above €100,000 84% are already on a €25,000 multiple. Keeping €1,000
// throughout gave 500 positions for ~250px of track, leaving 183 of them
// unreachable by drag at 390px. €5,000 is the widest top step that still lands
// on every €25,000 multiple.
const BANDS = [
  { upTo: 25000, step: 500 },
  { upTo: 50000, step: 1000 },
  { upTo: 500000, step: 5000 },
] as const;

const buildStops = (): number[] => {
  const stops = [1000];
  for (const { upTo, step } of BANDS) {
    for (
      let stop = stops[stops.length - 1] + step;
      stop <= upTo;
      stop += step
    ) {
      stops.push(stop);
    }
  }
  return stops;
};

export const AMOUNT_STOPS: readonly number[] = buildStops();

export const LAST_INDEX = AMOUNT_STOPS.length - 1;
export const MIN_AMOUNT = AMOUNT_STOPS[0];
export const MAX_AMOUNT = AMOUNT_STOPS[LAST_INDEX];

export function amountToIndex(amount: number): number {
  let nearest = 0;
  for (let index = 1; index < AMOUNT_STOPS.length; index++) {
    const isCloser =
      Math.abs(AMOUNT_STOPS[index] - amount) <=
      Math.abs(AMOUNT_STOPS[nearest] - amount);
    if (isCloser) nearest = index;
  }
  return nearest;
}

export function indexToAmount(index: number): number {
  const clamped = Math.min(Math.max(Math.round(index), 0), LAST_INDEX);
  return AMOUNT_STOPS[clamped];
}

export function snapToStop(amount: number): number {
  return indexToAmount(amountToIndex(amount));
}
